// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contNotiHost{
    position: absolute;
    /* background-color: aliceblue; */
    height: auto;
    width: auto;
    z-index: 2;
    display: block;
    justify-content: left;
    align-items: center;
    top: 13%;
    right: 3%;
}
.circle-NotiHost{
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #ff4b4b;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    color: aliceblue;
    font-weight: bold;
    right: -15%;
    top:-20%;
    padding: 2%;
    font-size: small;
}
.nonestate{
  background-color: #ff4b4b;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  height: 50%;
  width: auto;
  padding: 2px;
}
.okstate{
  background-color: green;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  height: 50%;
  width: auto;
  padding: 2px;
  color: var(--white-color);
}
.container-NotiHost {
    position: relative;
    box-sizing: border-box;
    width: -moz-fit-content;
    width: fit-content;
    z-index: 9;
  }
 
  
 
  
  
  .cont-row-NotiHost-txt{
    display: flex;
    justify-content: center;
  }
  
 
  .mainbox-NotiHost :hover{
    cursor: pointer;
  }
  .mainbox-NotiHost {
    box-sizing: border-box;
    position: relative;
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    border-radius: 160px;
    background-color: var(--white-color);
    transition: all 0.3s ease;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
  border: 2px solid var(--main-color) ;
z-index: 9;
  }
  .iconcontainer-NotiHost img{
    width: 60%;
    left: 20%;
    position: relative;
  }
  .checkbox-NotiHost:focus {
    border: none;
    outline: none;
  }
  
  .checkbox-NotiHost:checked {
    right: 10px !important;
    left: unset;
  }
  
  .checkbox-NotiHost:checked ~ .mainbox-NotiHost {
    width: 50px;
  }
  .checkbox-NotiHost:checked ~ .container-NotiHost-list {
    display: none;
  }
  
  .checkbox-NotiHost:checked ~ .mainbox-NotiHost .search_input-NotiHost {
    width: 0;
    height: 0px;
  }
  
  .checkbox-NotiHost:checked ~ .mainbox-NotiHost .iconcontainer-NotiHost {
    padding-right: 8px;
  }
  
  .checkbox-NotiHost {
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    position: absolute;
    /* right: 17px; */
    left: 185px;
    top: 10px;
    z-index: 9;
    cursor: pointer;
    appearance: none;
  }
  

  .contNotiHostList{
    position: absolute;
    width: 25%;
    height: 60%;
    z-index: 9;
    right: 3%;
    top: 21%;
    border-radius: 10px;
    background-color: var(--white-color);
    transition: all 0.3s ease;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
  border: 2px solid var(--main-color) ;
  overflow-x: scroll;
  overflow-x: hidden;

  }

  .contNotiInfo{
    position: relative;
    width: 100%;
    height: 100px;
    /* background-color: aliceblue; */
    border-bottom: 1px solid var(--border-table-color);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .compactNotiInfo{
    position: relative;
    width: 95%;
    height: 90%;
    display: flex;
  }
  .noseen{
    background-color: rgba(89, 89, 89, 0.34);
    border-radius: 10px;
    
  }
  .compactNotiInfo:hover{
    cursor: pointer;
    background-color: rgba(128, 128, 128, 0.308);
  }
  .leftContentNotiInfo{
    position: relative;
    height: 100%;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .RigthContentNotiInfo{
    position: relative;
    height: 100%;
    width: 85%;
    display: block;
    justify-content: center;
    align-items: center;
  }
  .RowContentNotiInfo{
    position: relative;
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: x-small;
    color: var(--txt-color);
  }
  
 .leftContentNotiInfo img{
    width: 50%;
 }
  
  .contNotiHostList circle{
    stroke: hsl(216, 21%, 60%);
  }


  .contSeeMore{
    position: absolute;
    width: 100%;
    height: 10%;
    background-color: rgba(240, 248, 255, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color:var(--txt-color);
    font-size: small;
  }
  .contSeeMore:hover{
    cursor: pointer;
    background-color: var(--hover-blue-list);
    color: #004e94;
   
  }

  /* Cambiar el ancho del scroll */
::-webkit-scrollbar {
  width: 4px;
  border-radius: 10px;
}

/* Cambiar el fondo del track del scroll */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* Cambiar el color del thumb (el "barra" del scroll) */
::-webkit-scrollbar-thumb {
  background-color: rgba(219, 219, 219, 0.658);
}

/* Cambiar el color del thumb cuando se pasa el mouse sobre él */
::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
::-webkit-scrollbar-thumb {
  background-color: #ffffff;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Notifications.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,WAAW;IACX,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,QAAQ;IACR,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,gBAAgB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAkB;IAAlB,kBAAkB;IAClB,UAAU;EACZ;;;;;;EAMA;IACE,aAAa;IACb,uBAAuB;EACzB;;;EAGA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,oCAAoC;IACpC,yBAAyB;IACzB,8CAA8C;EAChD,oCAAoC;AACtC,UAAU;EACR;EACA;IACE,UAAU;IACV,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;;EAGA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,oCAAoC;IACpC,yBAAyB;IACzB,8CAA8C;EAChD,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,kDAAkD;IAClD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;EACf;EACA;IACE,wCAAwC;IACxC,mBAAmB;;EAErB;EACA;IACE,eAAe;IACf,4CAA4C;EAC9C;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;EACzB;;CAED;IACG,UAAU;CACb;;EAEC;IACE,0BAA0B;EAC5B;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,wCAAwC;IACxC,cAAc;;EAEhB;;EAEA,gCAAgC;AAClC;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".contNotiHost{\r\n    position: absolute;\r\n    /* background-color: aliceblue; */\r\n    height: auto;\r\n    width: auto;\r\n    z-index: 2;\r\n    display: block;\r\n    justify-content: left;\r\n    align-items: center;\r\n    top: 13%;\r\n    right: 3%;\r\n}\r\n.circle-NotiHost{\r\n    position: absolute;\r\n    width: 25px;\r\n    height: 25px;\r\n    border-radius: 50%;\r\n    background-color: #ff4b4b;\r\n    z-index: 10;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: aliceblue;\r\n    font-weight: bold;\r\n    right: -15%;\r\n    top:-20%;\r\n    padding: 2%;\r\n    font-size: small;\r\n}\r\n.nonestate{\r\n  background-color: #ff4b4b;\r\n  font-weight: bold;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  height: 50%;\r\n  width: auto;\r\n  padding: 2px;\r\n}\r\n.okstate{\r\n  background-color: green;\r\n  font-weight: bold;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 10px;\r\n  height: 50%;\r\n  width: auto;\r\n  padding: 2px;\r\n  color: var(--white-color);\r\n}\r\n.container-NotiHost {\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    width: fit-content;\r\n    z-index: 9;\r\n  }\r\n \r\n  \r\n \r\n  \r\n  \r\n  .cont-row-NotiHost-txt{\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n \r\n  .mainbox-NotiHost :hover{\r\n    cursor: pointer;\r\n  }\r\n  .mainbox-NotiHost {\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    width: 50px;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 160px;\r\n    background-color: var(--white-color);\r\n    transition: all 0.3s ease;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n  border: 2px solid var(--main-color) ;\r\nz-index: 9;\r\n  }\r\n  .iconcontainer-NotiHost img{\r\n    width: 60%;\r\n    left: 20%;\r\n    position: relative;\r\n  }\r\n  .checkbox-NotiHost:focus {\r\n    border: none;\r\n    outline: none;\r\n  }\r\n  \r\n  .checkbox-NotiHost:checked {\r\n    right: 10px !important;\r\n    left: unset;\r\n  }\r\n  \r\n  .checkbox-NotiHost:checked ~ .mainbox-NotiHost {\r\n    width: 50px;\r\n  }\r\n  .checkbox-NotiHost:checked ~ .container-NotiHost-list {\r\n    display: none;\r\n  }\r\n  \r\n  .checkbox-NotiHost:checked ~ .mainbox-NotiHost .search_input-NotiHost {\r\n    width: 0;\r\n    height: 0px;\r\n  }\r\n  \r\n  .checkbox-NotiHost:checked ~ .mainbox-NotiHost .iconcontainer-NotiHost {\r\n    padding-right: 8px;\r\n  }\r\n  \r\n  .checkbox-NotiHost {\r\n    box-sizing: border-box;\r\n    width: 30px;\r\n    height: 30px;\r\n    position: absolute;\r\n    /* right: 17px; */\r\n    left: 185px;\r\n    top: 10px;\r\n    z-index: 9;\r\n    cursor: pointer;\r\n    appearance: none;\r\n  }\r\n  \r\n\r\n  .contNotiHostList{\r\n    position: absolute;\r\n    width: 25%;\r\n    height: 60%;\r\n    z-index: 9;\r\n    right: 3%;\r\n    top: 21%;\r\n    border-radius: 10px;\r\n    background-color: var(--white-color);\r\n    transition: all 0.3s ease;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n  border: 2px solid var(--main-color) ;\r\n  overflow-x: scroll;\r\n  overflow-x: hidden;\r\n\r\n  }\r\n\r\n  .contNotiInfo{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100px;\r\n    /* background-color: aliceblue; */\r\n    border-bottom: 1px solid var(--border-table-color);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .compactNotiInfo{\r\n    position: relative;\r\n    width: 95%;\r\n    height: 90%;\r\n    display: flex;\r\n  }\r\n  .noseen{\r\n    background-color: rgba(89, 89, 89, 0.34);\r\n    border-radius: 10px;\r\n    \r\n  }\r\n  .compactNotiInfo:hover{\r\n    cursor: pointer;\r\n    background-color: rgba(128, 128, 128, 0.308);\r\n  }\r\n  .leftContentNotiInfo{\r\n    position: relative;\r\n    height: 100%;\r\n    width: 15%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .RigthContentNotiInfo{\r\n    position: relative;\r\n    height: 100%;\r\n    width: 85%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .RowContentNotiInfo{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 25%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: x-small;\r\n    color: var(--txt-color);\r\n  }\r\n  \r\n .leftContentNotiInfo img{\r\n    width: 50%;\r\n }\r\n  \r\n  .contNotiHostList circle{\r\n    stroke: hsl(216, 21%, 60%);\r\n  }\r\n\r\n\r\n  .contSeeMore{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 10%;\r\n    background-color: rgba(240, 248, 255, 0);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color:var(--txt-color);\r\n    font-size: small;\r\n  }\r\n  .contSeeMore:hover{\r\n    cursor: pointer;\r\n    background-color: var(--hover-blue-list);\r\n    color: #004e94;\r\n   \r\n  }\r\n\r\n  /* Cambiar el ancho del scroll */\r\n::-webkit-scrollbar {\r\n  width: 4px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Cambiar el fondo del track del scroll */\r\n::-webkit-scrollbar-track {\r\n  background-color: transparent;\r\n}\r\n\r\n/* Cambiar el color del thumb (el \"barra\" del scroll) */\r\n::-webkit-scrollbar-thumb {\r\n  background-color: rgba(219, 219, 219, 0.658);\r\n}\r\n\r\n/* Cambiar el color del thumb cuando se pasa el mouse sobre él */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-color: #555;\r\n}\r\n::-webkit-scrollbar-thumb {\r\n  background-color: #ffffff;\r\n  border-radius: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
